import { Loader2 } from 'lucide-react';
import { format } from 'date-fns';

interface AutoSaveIndicatorProps {
  isSaving: boolean;
  lastSaved: Date | null;
}

export function AutoSaveIndicator({ isSaving, lastSaved }: AutoSaveIndicatorProps) {
  if (!isSaving && !lastSaved) return null;

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      {isSaving && (
        <Loader2 className="h-3 w-3 animate-spin text-green-500" />
      )}
      {lastSaved && (
        <span>Last saved at {format(lastSaved, 'HH:mm:ss')}</span>
      )}
    </div>
  );
}